import { hookstate } from "@hookstate/core";

export const ThemeState = hookstate({theme:'dark'});
